module.exports = __webpack_public_path__ + "media/images/floor_plan/table_1-3c6769eb5b78eaa62d5d2630a983f312.svg";